import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import Slider from 'react-slick';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDoubleRight} from '@fortawesome/pro-regular-svg-icons';
import {faChevronRight, faChevronLeft} from '@fortawesome/pro-solid-svg-icons';
import _ from "lodash";

class NewsTeaserBlock extends Component {
    constructor(props) {
        super(props);

        const SlickButtonFix = ({currentSlide, slideCount, children, ...props}) => (
            <button {...props}>{children}</button>
        );

        this.slickSettings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: (
                <SlickButtonFix>
                    <FontAwesomeIcon icon={faChevronRight}/>
                </SlickButtonFix>
            ),
            prevArrow: (
                <SlickButtonFix>
                    <FontAwesomeIcon icon={faChevronLeft}/>
                </SlickButtonFix>
            )
        };
    }

    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    render() {
        const blocks = [];

        blocks.push({
            Title: this.getContentFieldValue('Title'),
            Image: this.getContentFieldValue('Image'),
            Body: this.getContentFieldValue('Body'),
            NewsLink: this.getContentFieldValue('NewsLink'),
            Width: this.getContentFieldValue('Width'),
        });

        return (
            <section className={"blog-slider w--" + this.getBlockWidth() + " show--shadow"}>
                <section className="blog-slider--inner">
                    <Slider {...this.slickSettings} className="blogSlider">
                        {blocks.map((item, key) => {
                            const thumbnail = item.Image ? item.Image.mediaUrl : false;
                            const link = item.NewsLink ? item.NewsLink : false;

                            let url = '#';

                            if (link.page) {
                                url = `#/page/${link.contentId}`;
                            } else if (link.url) {
                                url = link.url;
                            }

                            return (
                                <div key={key} className="slide">
                                    <div className="slide--inner">
                                        {thumbnail && (
                                            <figure
                                                className="thumbnail-container"
                                                style={{backgroundImage: `url(${thumbnail})`}}>
                                            </figure>
                                        )}
                                        <div className="content">
                                            <h3>{item.Title}</h3>
                                            <div dangerouslySetInnerHTML={{__html: item.Body}}/>
                                            <a href={url}>
                                                <span>{link.title ? link.title : "Read more"}</span>
                                                <FontAwesomeIcon icon={faChevronDoubleRight}/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </section>
            </section>
        );
    }
}

export default NewsTeaserBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/NewsTeaserBlock.js